// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2LUjh","dragIcon":"Choice_dragIcon__2AY-Z","left":"Choice_left__1YV2v","input":"Choice_input__1HuFJ"};